import React, { useState, useEffect } from 'react';
import NavigationMobileMenuSubItem from '../NavigationMobileMenuSubItem';

const NavigationMobileMenuitem = ({ item, handleLinkClick, closeAllModals,
}) => {

  const href = item.getIn(['link', 'url'], '');
  const title = item.getIn(['link', 'title'], 'Untitled');
  const [isOpen, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!isOpen);
  };

  const onLinkClick = () => {
    toggleOpen();
    handleLinkClick();
  };

  useEffect(() => {
    setOpen(false);
  }, [closeAllModals]);

  return (
    <li
      key={`menu--main--menu-item-${title}:${href}`}
      className="menu--main--menu-item"
    >
      <div className="LegacyNavigationMainMenuMobile--subMenu__items">

        {item.getIn(['subtree']).map((subItem, index) => {
          const menuId = subItem.getIn(['link', 'title']);
          return (
            <NavigationMobileMenuSubItem
              closeAllModals={closeAllModals}
              key={menuId}
              subItem={subItem}
              handleLinkClick={onLinkClick}
            />
          );
        })}

      </div>
    </li>
  );
};

export default NavigationMobileMenuitem;
